// Resolucao dos destinos de uma origem conforme o modo de encaminhamento.
//   simple  : toda origem envia para todos os destinos ativos;
//   advanced: so as rotas cadastradas para a origem; origem sem rota nao envia.
// Sempre remove a propria origem (anti-loop) e respeita o limite do plano.
export function resolveDestinations(input) {
    const active = input.destinations.filter((d) => d !== input.sourceRef);
    const allowed = input.maxDestinations === null ? active : active.slice(0, Math.max(0, input.maxDestinations));
    if (input.mode === "simple") {
        return [...new Set(allowed)];
    }
    const routed = new Set(input.routes.filter((r) => r.sourceRef === input.sourceRef).map((r) => r.destinationRef));
    return [...new Set(allowed.filter((d) => routed.has(d)))];
}
/** Origens que nao enviam para ninguem (para a tela de saude). */
export function sourcesWithoutDestination(mode, sources, destinations, routes) {
    return sources.filter((sourceRef) => resolveDestinations({ mode, sourceRef, destinations, routes, maxDestinations: null })
        .length === 0);
}
//# sourceMappingURL=routing.js.map